/**
 * App build-time cofigurations
 * devConfig is used when running in development mode - via `npm start`
 * prodConfig is used when building in production mode - `npm run build`
 */

const devConfig = {
    // development_mode: true,
    suggest_domains_on_login: true,
    api_base_url: 'http://localhost:8080/SMC/api/v2', // localhost
    api_request_timeout: 50000, // Timeout in miliseconds
    results_page_size: 30000,
    google_maps_api_client: 'gme-checkpointsoftware',
    google_maps_api_key: 'AIzaSyBHy4mIRZAYMLpQDoUDSNx9xXi0el7Tjac',
    google_captcha_key: '6LeUJGsUAAAAAEgKA3R7Y5qnJPgTNfnwo7u7Rnj8'
};

const prodConfig = {
    api_base_url: '/SMC/api/v2', // self
    api_request_timeout: 50000, // Timeout in miliseconds
    results_page_size: 30000,
    google_maps_api_client: 'gme-checkpointsoftware',
    google_maps_api_key: 'AIzaSyBHy4mIRZAYMLpQDoUDSNx9xXi0el7Tjac',
    google_captcha_key: '6LeUJGsUAAAAAEgKA3R7Y5qnJPgTNfnwo7u7Rnj8'
};

let config;
switch (process.env.NODE_ENV) {
    case 'development':
        config = devConfig;
        break;
    case 'production':
    default:
        config = prodConfig; // Default config is production
        break;
}

export default config;